<template>
  <v-navigation-drawer
    v-model="isShowForm"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px;"
    stateless
  >
    <div class="d-flex flex-column" style="height: calc(100% - 64px);">
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleClickBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              เลือกพนักงาน
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ commandData.title }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar>
      <div class="px-5 pb-5" style="height: 100%; overflow: auto;">
        <v-form ref="form" lazy-validation>
          <div class="d-flex">
            <v-text-field
              v-model="search"
              class="mr-2"
              placeholder="ค้นหา"
            ></v-text-field>
            <v-autocomplete
              v-model="selectedOrganization"
              label="เลือกหน่วยงาน"
              :items="organizations"
              item-value="organization_uuid"
              item-text="title_th"
              clearable
              @change="handleChange"
            ></v-autocomplete>
          </div>
          <div class="d-flex align-center" v-if="filterEmployees.length > 0">
            <v-btn icon @click="handleToggleCheckAll">
              <v-icon>{{ checkAllIcon }}</v-icon>
            </v-btn>
            <span>
              เลือกทั้งหมด {{ selectedEmployees.length }}/{{
                filterEmployees.length
              }}
              คน
            </span>
          </div>
          <div
            class="box_card my-2"
            v-for="employee in filterEmployees"
            :key="employee.employee_uuid"
          >
            <input
              type="checkbox"
              :value="employee"
              v-model="selectedEmployees"
            />
            <div class="ml-4">
              <h2>{{ employee.firstname_th }} {{ employee.lastname_th }}</h2>
              <div>
                <span class="mr-2">
                  ตำแหน่ง {{ employee.position.title_th }}
                </span>
                <span>{{ employee.employee_code }}</span>
              </div>
            </div>
          </div>
          <div class="mt-3 text-center" v-if="filterEmployees.length === 0">
            ไม่มีข้อมูล
          </div>
        </v-form>
      </div>
      <v-toolbar
        flat
        color="blue-grey lighten-5"
        class="d-flex align-center justify-center"
      >
        <button
          :disabled="selectedEmployees.length === 0"
          @click="handleClickSendCommand"
          type="button"
          class="mr-3"
          :class="{ 'cursor-not-allowed': selectedEmployees.length === 0 }"
        >
          ส่งข้อมูล
        </button>
        <div class="d-sr-only">{{ isDataChange }}</div>
        <v-icon>mdi-arrow-right</v-icon>
      </v-toolbar>
    </div>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog
  },

  props: {
    isShowForm: {
      type: Boolean,
      required: true
    },
    commandData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      search: '',
      selectedOrganization: '',
      selectedEmployees: []
    }
  },

  watch: {
    commandData(newValue, oldValue) {
      if (Object.keys(newValue).length === 0) {
        this.selectedEmployees = []
        this.search = ''
        this.selectedOrganization = ''
      }
    }
  },

  computed: {
    isDataChange() {
      if (this.selectedEmployees.length > 0) {
        this.$emit('isHardwareConnectionFormEmployeeListDataChange', true)
        return true
      } else {
        this.$emit('isHardwareConnectionFormEmployeeListDataChange', false)
        return false
      }
    },
    organizations() {
      return this.$store.state.hardware.organizations
    },
    employees() {
      return this.$store.state.hardware.employees
    },
    checkAllIcon() {
      if (this.selectedEmployees.length === this.filterEmployees.length) {
        return 'mdi-checkbox-marked'
      } else if (this.selectedEmployees.length > 0) {
        return 'mdi-minus-box'
      } else {
        return 'mdi-checkbox-blank-outline'
      }
    },
    filterEmployees() {
      let items = this.employees

      if (this.search) {
        items = items.filter(item => {
          return Object.values({
            employee_code: item.employee_code,
            fullName: `${item.firstname_th} ${item.lastname_th}`,
            position: item.position.title_th
          }).some(s =>
            s
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase())
          )
        })
      }

      if (this.selectedOrganization) {
        items = items.filter(
          item =>
            item.organization.organization_uuid === this.selectedOrganization
        )
      }

      return items
    }
  },

  methods: {
    handleToggleCheckAll() {
      if (this.selectedEmployees.length === this.filterEmployees.length) {
        this.selectedEmployees = []
      } else {
        this.selectedEmployees = this.filterEmployees
      }
    },
    handleChange() {
      this.selectedEmployees = []
    },
    handleClickBack() {
      if (this.isDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการละทิ้งการดำเนินการทั้งหมด?',
          text:
            'คุณยังไม่ได้ดำเนินการ คุณแน่ใจหรือไม่ว่าต้องการละทิ้งการดำเนินการทั้งหมด',
          value: ''
        }
        this.confirmDialogDataChange = true
      } else {
        this.selectedEmployees = []
        this.$emit('onClickBack')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.selectedEmployees = []
      this.$emit('onClickBack')
    },
    sendCommand() {
      const payload = {
        ...this.commandData,
        employees: this.selectedEmployees
      }
      this.$emit('onClickSendCommand', payload)
    },
    handleClickSendCommand() {
      if (this.commandData.syncCode === 'delete_employee') {
        let results = ''
        if (this.selectedEmployees.length > 1) {
          results = `ทั้งหมด ${this.selectedEmployees.length} คน`
        } else {
          results = `${this.selectedEmployees[0].firstname_th} ${this.selectedEmployees[0].lastname_th}`
        }
        this.confirmDialogDelete = true
        this.confirmDialogDeleteData = {
          title: 'ยืนยันการลบ',
          text: 'คุณต้องการลบพนักงาน',
          value: results
        }
      } else {
        this.sendCommand()
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete() {
      this.confirmDialogDelete = false
      this.sendCommand()
    }
  }
}
</script>

<style scoped>
.box_card {
  border: 1px solid #eee;
  border-radius: 3px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
}
.box_card h2 {
  font-size: 16px;
  color: #424242;
}
.box_card span {
  font-size: 14px;
}
.box_card input[type='checkbox'] {
  cursor: pointer;
  transform: scale(1.5);
}
</style>
